const navConfig = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    path: '/dashboard/home',
    icon: 'dashboard',
  },
  {
    id: 'users',
    title: 'Users',
    path: '/dashboard/users',
    icon: 'user',
  },
  {
    id: 'subscription',
    title: 'Subscription',
    path: '/dashboard/subscription',
    icon: 'subscription',
  },
  {
    id: 'settings',
    title: 'Settings',
    path: '/dashboard/settings',
    icon: 'settings',
  },
];

export function getActiveNavId(pathname = '') {
  if (pathname === '/dashboard/student-stats' || pathname.startsWith('/dashboard/student-stats')) {
    return 'users';
  }

  const match = navConfig.find(
    (item) => pathname === item.path || pathname.startsWith(`${item.path}/`)
  );
  return match?.id || 'dashboard';
}

export default navConfig;
